<dashboard-dialog-frame class="video-dialog" header="Video" [actions]="actions" [dialogRef]="dialogRef">
	@if(signedVideoUrl(); as signedVideoUrl){
	<div class="d-flex justify-content-center align-items-center h-100">
		<div class="portrait-container">
			<common-video-player [noBorderRadius]="true" [videoUrl]="signedVideoUrl"
				(isVideoError)="onVideoError()"></common-video-player>
		</div>
	</div>
	}
</dashboard-dialog-frame>